import React from 'react';
import { Row, Col, Card, Button, Table, message } from 'antd';
import { ArrowDownOutlined } from '@ant-design/icons';

import { database_columns, database_source } from './table_config';
import dna from '../../images/dna.png';
import topoloy from '../../images/topoloy.png';
import flask from '../../images/flask.png';

const Download = () => {
    const download = async (fileType) => {
        const fileMap = {
            "gdc_variant": "all_gdc_variant.gz",
            "gdc_gene": "all_gdc_gene.7z",
            "hearing_loss_genes": "candidate_hearing_loss_genes.7z",
            "dvpred_variant": "all_dvpred_variant.gz"
        };
        const downloadFilename = fileMap[fileType] || "download_file";
        const url = process.env.NODE_ENV === 'development' ? 'http://127.0.0.1:5000' : 'http://124.223.194.210:8090';
        try {
            const link = document.createElement("a");
            link.href = `${url}/download?filetype=${fileType}`;
            link.setAttribute("download", downloadFilename);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
    
        } catch (error) {
            message.error("Download error:", error);
        }
    }

    return (
        <Row>
            <Col span={24} className="page-top-seize-seat" />
            <Col span={24} className="download-center download-contain">
                <span className="dvpred-title download-title">DOWNLOAD</span>
                <Row gutter={{xs: 6, sm: 12, md: 18, lg: 24}} style={{marginTop: '2vh'}}>
                    <Col xl={6} lg={12} md={24} sm={24} xs={24}>
                        <Card
                            title={<span className='card-title'>All GDC Variants</span>}
                            bordered={false}
                            className="download-item"
                            style={{minHeight: '320px'}}
                        >
                            <div className="circle" />
                            <img src={dna} alt="dna" className="download-item-icon" />
                            <span className="download-item-date">July 30th, 2024</span>
                            <p className="download-item-description">
                                This file contains all annotated variants in the GDC. Due to the internal data usage of the Chinese Deafness Genetics Consortium (CDGC), the download will be available upon the publication of the CDGC manuscript.
                            </p>
                            <Row className="download-item-bottom">
                                <Col span={4}>613M</Col>
                                <Col span={20} style={{textAlign: 'right'}}>
                                    <Button icon={<ArrowDownOutlined />} className="download-btn" onClick={() => download("gdc_variant")}>Download</Button>
                                </Col>
                            </Row>
                        </Card>
                    </Col>
                    <Col xl={6} lg={12} md={24} sm={24} xs={24}>
                        <Card
                            title={<span className='card-title'>All GDC Genes</span>}
                            bordered={false}
                            className="download-item"
                            style={{minHeight: '320px'}}
                        >
                            <div className="circle" />
                            <img src={topoloy} alt="topoloy" className="download-item-icon" />
                            <span className="download-item-date">July 30th, 2024</span>
                            <p className="download-item-description">
                                This file contains all genes in the GDC.
                            </p>
                            <Row className="download-item-bottom">
                                <Col span={4}>180KB</Col>
                                <Col span={20} style={{textAlign: 'right'}}>
                                    <Button icon={<ArrowDownOutlined />} className="download-btn" onClick={() => download("gdc_gene")}>Download</Button>
                                </Col>
                            </Row>
                        </Card>
                    </Col>
                    <Col xl={6} lg={12} md={24} sm={24} xs={24}>
                        <Card
                            title={<span className='card-title'>All DVPred Variants</span>}
                            bordered={false}
                            className="download-item"
                            style={{minHeight: '320px'}}
                        >
                            <div className="circle" />
                            <img src={flask} alt="flask" className="download-item-icon" />
                            <span className="download-item-date">July 30th, 2024</span>
                            <p className="download-item-description">
                                This file contains the site information of DvPred prediction results.
                            </p>
                            <Row className="download-item-bottom">
                                <Col span={4}>28.3M</Col>
                                <Col span={20} style={{textAlign: 'right'}}>
                                    <Button icon={<ArrowDownOutlined />} className="download-btn" onClick={() => download("dvpred_variant")}>Download</Button>
                                </Col>
                            </Row>
                        </Card>
                    </Col>
                    <Col xl={6} lg={12} md={24} sm={24} xs={24}>
                        <Card
                            title={<span className='card-title'>Candidate Hearing Loss Genes</span>}
                            bordered={false}
                            className="download-item"
                            style={{minHeight: '320px'}}
                        >
                            <div className="circle" />
                            <img src={flask} alt="flask" className="download-item-icon" />
                            <span className="download-item-date">Dec 16th, 2024</span>
                            <p className="download-item-description">
                            This file contains information about candidate HL genes predicted by machine learning using a comprehensive expression and functional annotation dataset.
                            </p>
                            <Row className="download-item-bottom">
                                <Col span={4}>163k</Col>
                                <Col span={20} style={{textAlign: 'right'}}>
                                    <Button icon={<ArrowDownOutlined />} className="download-btn" onClick={() => download("hearing_loss_genes")}>Download</Button>
                                </Col>
                            </Row>
                        </Card>
                    </Col>
                </Row>
            </Col>
            <Col span={24} className="download-contain">
                <span className="download-contain ant-card-head-title">PUBLIC DATA</span>
                <Table
                    bordered={false}
                    columns={database_columns}
                    dataSource={database_source}
                    scroll={{ x: 'max-content' }}
                />
            </Col>
        </Row>
    )
}

export default Download